export default {
  security_code: `<b>セキュリティコード</b><br>
    セキュリティコードとは、クレジットカードの裏面の署名欄に印字されている、<br>
    3〜4桁の数字のことです。<br>American Express の場合は、表面に印字されていることがあります。`,
}
